import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export default function Survey() {

    const {t} = useTranslation()

    return(
        <Box sx={{mt: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%"}}>
            <Paper sx={{p: 2, m: 2}}>
                <Typography sx={{mb: 0}} variant="h1">{t("surveyTitle")}</Typography>
            </Paper>
            <Paper elevation={0} sx={{display: "flex", flexDirection: "column", alignItems: "center", m: {xs: 1, sm: 2}, maxWidth: 800}}>
                <Outlet />
            </Paper>
        </Box>
    )
}